export enum VehicleDriverState {
  identified = 'IDENTIFIED',
  unauthorized = 'UNAUTHORIZED',
  no_data = 'NO_DATA',
  unrecognized_id_number = 'UNRECOGNIZED_ID_NUMBER',
}
